import React, { useEffect, useRef } from "react";
import cn from "classnames";
import CONFIG from "../../config";
import { EPAGE, IBaseProps } from "../../types";
import TBankPaymentForm from "./TBankPaymentForm/TBankPaymentForm";
import WherePay from "./WherePay/WherePay";

import TBankLogo from '../../assets/img/icons/t-bank-logo.svg';
//import TBankName from '../../assets/img/icons/t-bank-name.svg';

const { LINKS } = CONFIG;

const Main: React.FC<IBaseProps> = ({ page = EPAGE.INDEX }) => {
    const errOkRef = useRef<HTMLParagraphElement>(null!);

    useEffect(() => {
        const urlError = document.location.search;
        if (urlError === '?error=contract') {
            errOkRef.current.classList.add('show');
        }
    });

    return (
        <main>
            <section className="pay__money">
                <div className="section__wrapper">
                    {page === EPAGE.INDEX && <h1>Оплатить заём картой любого банка</h1>}
                    {page === EPAGE.ERROR && <h1>Оплатить заём</h1>}
                    <p ref={errOkRef} className={cn("err-ok", { 'show': page === EPAGE.ERROR })}>Ввёден неправильный номер договора</p>
                    <div className="pay__tabs">
                        <div className="tab__title tinkof active">
                            <span className="tab__icon">
                                <img src={TBankLogo} alt="Оплатить через Т-Банк" />
                                {/*<img src={TBankName} alt="Оплатить через Т-Банк" />*/}
                            </span>
                            Оплатить через Т-Банк
                        </div>
                    </div>
                    <div className="pay__tabs__container">
                        <div className="tab__content show">
                            <TBankPaymentForm />
                        </div>
                    </div>
                    <div className="video__instruction">
                        <a href={LINKS.VIDEO_INSTRUCTION} target="_blank" rel="noopener noreferrer nofollow">Видеоинструкция</a> по погашению займа
                    </div>
                </div>
            </section>
            <WherePay />
        </main>
    );
}

export default Main;